// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"827":"9ae7bd40","897":"07c96347"}[chunkId] + ".chunk.js";
};